import { useTranslation } from 'react-i18next';
import { Link } from '@tanstack/react-router';
import { AppLayout } from '@/app/layout/AppLayout';

/**
 * Frontendová 404 stránka.
 * Zobrazuje se pro neznámé frontendové cesty uvnitř SPA shellu.
 *
 * Tato stránka se liší od backendového 404 - backend vrací SPA shell,
 * a teprve klient rozpozná neznámou cestu a zobrazí tuto stránku.
 */
export function NotFoundPage() {
  const { t } = useTranslation('not-found');

  return (
    <AppLayout>
      <div className="flex min-h-[60vh] flex-col items-center justify-center text-center">
        <div className="text-muted-foreground/20 mb-8 text-8xl font-bold">404</div>

        <h1 className="text-foreground mb-4 text-3xl font-bold tracking-tight">
          {t('notFound.title')}
        </h1>

        <p className="text-muted-foreground mb-8 max-w-md text-lg">{t('notFound.description')}</p>

        <Link
          to="/"
          className="bg-primary text-primary-foreground hover:bg-primary/90 focus-visible:ring-ring inline-flex items-center justify-center gap-2 rounded-md px-6 py-3 text-sm font-medium shadow transition-colors focus-visible:ring-1 focus-visible:outline-none"
          data-testid="link-back-home"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="m12 19-7-7 7-7" />
            <path d="M19 12H5" />
          </svg>
          {t('notFound.backToHome')}
        </Link>
      </div>
    </AppLayout>
  );
}
